export default __webpack_public_path__ + "static/media/green-up-arrow.e14ce2ad.png";